import { getPropertyKey, mapPropertySearchResults, propertyMigrationAdapters, SearchMigrationAdapter } from 'stores/adapters';
import { mapMap } from 'src/common/stores/adapters/bex-api/search/map-adapter';

import { HotelResultsViewModel, HotelViewModel } from 'models';

import { OperationResult, PropertyMapMigration } from '__generated__/api';

export const adaptMapAndProperties: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;

  if (!propertySearch || !propertySearch.properties || !propertySearch.map) {
    return bffResults;
  }

  return {
    ...bffResults,
    hotels: mapPropertySearchResults(data),
    map: mapMap(data)
  };
};

export const adaptRolledOutSpinnerData: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>,
  bexApiPropertyDict: { [key: string]: PropertyMapMigration.Properties }
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;

  if (!propertySearch || (!propertySearch.map && !propertySearch.properties)) {
    return bffResults;
  }

  return {
    ...bffResults,
    map: mapMap(data),
    hotels: adaptRolledOutPropertyFeatures(bffResults, bexApiPropertyDict)
  };
};

const adaptRolledOutPropertyFeatures = (
  bffResults: HotelResultsViewModel,
  bexApiPropertyDict: { [key: string]: PropertyMapMigration.Properties }
): HotelViewModel[] =>
  bffResults.hotels.map(hotel => {
    const property = bexApiPropertyDict[getPropertyKey(String(hotel.id), hotel.travelAd)];

    if (property) {
      let hotelCopy: HotelViewModel = { ...hotel };

      propertyMigrationAdapters.forEach(adapter => {
        hotelCopy = adapter(property, hotelCopy);
      });

      return hotelCopy;
    }

    return hotel;
  });
